import { render, staticRenderFns } from "./CertificateTreatment.vue?vue&type=template&id=219ddbb0&scoped=true&"
import script from "./CertificateTreatment.vue?vue&type=script&lang=ts&"
export * from "./CertificateTreatment.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateTreatment.vue?vue&type=style&index=0&id=219ddbb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ddbb0",
  null
  
)

export default component.exports